import React from 'react';
import { FaGithub, FaGlobe } from 'react-icons/fa';
import './ProductCard.css';

const ProductCard = ({ row }) => {
    const {
        'Product/ Products': ProductProducts,
        Product,
        'Product  Type': ProductType,
        'Org Type': OrgType,
        'Primary product Domain': PrimaryDomain,
        'Secondary Domain': SecondaryDomain,
        'Repo links': Repo,
        'Use cases': UseCases,
        'webiste link': Website,
        POC,
        Logo,
        'Logo,Column 1': LogoAlt
    } = row;

    const logoUrl = Logo && Logo.startsWith('http') ? Logo : (LogoAlt && LogoAlt.startsWith('http') ? LogoAlt : null);
    const techUsed = OrgType ? OrgType.split(',').map(t => t.trim()).filter(Boolean) : [];

    return (
        <div className="product-card">
            <div className="product-card-header">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left', marginRight: 18 }}>
                    {logoUrl && (
                        <img src={logoUrl} alt="logo" className="product-card-logo" />
                    )}
                </div>
                <div style={{ flex: 1 }}>
                    <div className="product-card-title" style={{ fontWeight: 700, fontSize: 20, margin: '10px 0', textAlign: 'left' }}>
                        {Product || ProductProducts}
                    </div>
                    <div className="product-card-badges" style={{ marginTop: 8 }}>
                        {PrimaryDomain && <span className="product-badge domain">{PrimaryDomain}</span>}
                        {SecondaryDomain && <span className="product-badge domain">{SecondaryDomain}</span>}
                        {techUsed.length > 0 && techUsed.map((tech, i) => (
                            <span key={i} className="product-badge tech">{tech}</span>
                        ))}
                        {ProductType && <span className="product-badge type">{ProductType}</span>}
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'left', gap: 10 }}>
                    {Repo && (
                        <a href={Repo} target="_blank" rel="noopener noreferrer" className="product-card-repo github-logo">
                            <FaGithub size={24} title="GitHub Repo" />
                        </a>
                    )}
                    {Website && (
                        <a href={Website} target="_blank" rel="noopener noreferrer" className="product-card-website">
                            <FaGlobe size={22} title="Website" />
                        </a>
                    )}
                </div>
            </div>
            {UseCases && (
                <div className="product-card-usecases-container">
                    <div className="product-card-section" style={{ marginTop: 12 ,textAlign: 'left'}}>
                        {UseCases}
                    </div>
                </div>
            )}
            {POC && (
                <div className="product-card-section" style={{ marginTop: 12 }}>
                    <strong>Contact :</strong> <span className="product-card-link">{POC}</span>
                </div>
            )}
        </div>
    );
};

export default ProductCard;